import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import "../../ui/Pages/ProfilePage/profile-sidebar.css";

const SidebarDeposit = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("deposit_fiat")) {
      setActiveTab("Deposit Fiat");
    } else if (path.includes("withdraw_fiat")) {
      setActiveTab("Withdraw Fiat");
    } else if (path.includes("deposit")) {
      setActiveTab("Deposit");
    } else if (path.includes("withdraw")) {
      setActiveTab("Withdraw");
    }
    setMobileNavOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (mobileNavOpen) {
      const scrollY = window.scrollY;
      document.documentElement.classList.add("profile-sidebar--open");
      document.body.classList.add("profile-sidebar--open");
      document.body.style.top = `-${scrollY}px`;

      return () => {
        document.documentElement.classList.remove("profile-sidebar--open");
        document.body.classList.remove("profile-sidebar--open");
        const top = document.body.style.top;
        document.body.style.top = "";
        if (top) {
          window.scrollTo(0, parseInt(top || "0", 10) * -1);
        }
      };
    } else {
      document.documentElement.classList.remove("profile-sidebar--open");
      document.body.classList.remove("profile-sidebar--open");
      document.body.style.top = "";
    }
  }, [mobileNavOpen]);

  const isDepositCryptoActive = activeTab === "Deposit";
  const isWithdrawCryptoActive = activeTab === "Withdraw";
  const isDepositFiatActive = activeTab === "Deposit Fiat";
  const isWithdrawFiatActive = activeTab === "Withdraw Fiat";

  const mobileTitle = activeTab || "Deposit Crypto";

  const mobileIconSrc =
    activeTab === "Withdraw" || activeTab === "Withdraw Fiat"
      ? "/images/arrowmenu2.svg"
      : "/images/arrowmenu.svg";

  const toggleMobileNav = () => setMobileNavOpen((v) => !v);

  const closeMobileNav = () => setMobileNavOpen(false);

  return (
    <>
      <div
        className={`mobile_view asset-sidebar-toggle${mobileNavOpen ? " mobile_view--open" : ""}`}
        id="toggleBtnAssetNav"
        role="button"
        tabIndex={0}
        onClick={toggleMobileNav}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleMobileNav();
          }
        }}
        aria-expanded={mobileNavOpen}
        aria-label="Toggle Deposit / Withdraw navigation"
      >
        <img src={mobileIconSrc} alt="" width={20} height={20} style={{ marginRight: 8 }} />
        <div className="d-flex align-items-center justify-content-between w-100">
          {mobileTitle}
          <span className="mobile_view__chevWrap" aria-hidden>
            <i className="ri-arrow-down-s-line mobile_view__chev" />
          </span>
        </div>
      </div>

      <div className="dashboard">
        <div
          id="content"
          className={`${mobileNavOpen ? "active " : ""}flex-shrink-0 leftside_menu profile-sidebar-shell${sidebarCollapsed ? " profile-sidebar-shell--collapsed" : ""
            }`}
        >
          <button
            type="button"
            className="profile-sidebar-collapse-btn"
            onClick={() => setSidebarCollapsed((c) => !c)}
            aria-expanded={!sidebarCollapsed}
            aria-label={sidebarCollapsed ? "Expand navigation" : "Collapse navigation"}
          >
            <i className={sidebarCollapsed ? "ri-arrow-right-s-line" : "ri-arrow-left-s-line"} aria-hidden="true" />
          </button>

          <ul className="list-unstyled ps-0 navi_sidebar">
            <li className={`mb-1 ${isDepositCryptoActive ? "active" : ""}`}>
              <Link to="deposit" onClick={closeMobileNav}>
                <img className="dark_img" src="/images/arrowmenu.svg" alt="" width={20} height={20} />
                <img className="light_img" src="/images/arrowmenu_light.svg" alt="" width={20} height={20} />
                <div className="dashboard_menu_hd">Deposit Crypto</div>
              </Link>
            </li>
            <li className={`mb-1 ${isWithdrawCryptoActive ? "active" : ""}`}>
              <Link to="withdraw" onClick={closeMobileNav}>
                <img className="dark_img" src="/images/arrowmenu2.svg" alt="" width={20} height={20} />
                <img className="light_img" src="/images/arrowmenu2_light.svg" alt="" width={20} height={20} />
                <div className="dashboard_menu_hd">Withdraw Crypto</div>
              </Link>
            </li>
            <li className={`mb-1 deposit-sidebar-fiat-item ${isDepositFiatActive ? "active" : ""}`}>
              <Link to="deposit_fiat" onClick={closeMobileNav}>
                <img className="dark_img" src="/images/deposit_fiat_icon.png" alt="" width={20} height={20} />
                <img className="light_img" src="/images/deposit_fiat_icon_light.png" alt="" width={20} height={20} />
                <div className="dashboard_menu_hd">Deposit Fiat</div>
              </Link>
            </li>
            <li className={`mb-1 ${isWithdrawFiatActive ? "active" : ""}`}>
              <Link to="withdraw_fiat" onClick={closeMobileNav}>
                <img className="dark_img" src="/images/withdrawal_fiat_icon.png" alt="" width={20} height={20} />
                <img className="light_img" src="/images/withdrawal_fiat_icon_light.png" alt="" width={20} height={20} />
                <div className="dashboard_menu_hd">Withdraw Fiat</div>
              </Link>
            </li>
          </ul>
        </div>

        <Outlet />
      </div>
    </>
  );
};

export default SidebarDeposit;
